import React from 'react';

const Button = ({ 
  children, 
  type = 'button', 
  variant = 'primary', 
  size = 'md',
  block = false,
  disabled = false,
  onClick,
  icon,
  loading = false
}) => {
  const classes = `btn btn-${variant} btn-${size} ${block ? 'btn-block' : ''}`;
  
  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading ? (
        <>
          <span className="loader loader-inline"></span>
          Loading...
        </>
      ) : (
        <>
          {icon && <span>{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
};

export default Button;